<template>
  <div class="cm-upload">
    <a-upload
      :accept="accept"
      listType="picture-card"
      :disabled="disabled"
      :fileList="fileList"
      @change="handleChange"
      @preview="handlePreview"
      :beforeUpload="beforeUpload"
      :remove="handleRemove"
      :customRequest="handleUpload"
    >
      <div v-if="fileList.length < max">
        <a-icon type="plus" />
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
      <img v-if="isImage" style="width: 100%" :src="previewFile.url || previewFile.thumbUrl" />
      <video v-else :src="previewFile.url || previewFile.thumbUrl" controls autoplay></video>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as qiniu from 'qiniu-js'
import md5 from 'md5'
export default {
  props: {
    defaultFileList: {
      type: Array,
      default: () => ([])
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    uploadDomain: {
      type: String,
      default: 'qns',
      requied: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 上传表单字段值
    field: {
      type: String,
      default: ''
    },
    // 存储目录
    dir: {
      type: String,
      default: 'common'
    },
    max: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      imageUrls: [],
      fileList: [],
      previewVisible: false,
      previewFile: '',
      isImage: true,
      uploading: false
    }
  },
  created () {
    this.fileList = this.defaultFileList
  },
  methods: {
    ...mapActions([
      'GetQiniuImageToken', // qns
      'GetQNPToken' // qnp
    ]),
    handleCancelPreview () {
      this.previewVisible = false
    },
    // getSize (src, callback) {
    //   const image = new Image()
    //   image.onload = () => {
    //     return callback(image.width, image.height)
    //   }
    //   image.src = src
    // },
    handleChange ({ file, fileList }) {
      this.fileList = fileList
      this.handleUpload()
    },
    handlePreview (file) {
      const imageReg = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/
      // const videoReg = /\.(mov|mp4|m4a|3gp|3g2|mj2)$/
      if (imageReg.test(file.name)) {
        this.isImage = true
      } else {
        this.isImage = false
      }
      this.previewFile = file
      this.previewVisible = true
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.imageUrls.splice(index, 1)
      this.fileList = newFileList

      // 移除时清空表单 title_image
      this.$emit('fnUploadSuccess', this.field, '')
    },
    beforeUpload (file) {
      // const imageReg = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/
      // const videoReg = /\.(mov|mp4|m4a|3gp|3g2|mj2)$/
      // const k = 1024
      // if (imageReg.test(file.name) && Math.floor(file.size / k) >= 50) {
      //   this.$message.error('图片最大50M，请重新上传')
      //   return false
      // }
      // if (videoReg.test(file.name) && Math.floor(file.size / k / k > 300)) {
      //   this.$message.error('视频最大300M，请重新上传')
      //   return false // 返回 false 则会停止自动上传， 需要手动调用 customRequest 指定的上传方法
      // }
      // return false
      this.fileList = [file]
      return false
    },
    handleUpload () {
      // const formData = new FormData()
      // fileList.forEach((file) => {
      //   formData.append('files[]', file)
      // })
      const getTokenActions = {
        'qns': this.GetQiniuImageToken(),
        'qnp': this.GetQNPToken()
      }
      const fileList = this.fileList
      getTokenActions[this.uploadDomain]
        .then(res => {
          fileList.forEach((file, index) => {
            const name = md5(Date.now() + index + Math.random())
            const key = `${this.dir}/${name}.${file.type.split('/')[1]}`
            const observable = qiniu.upload(file.originFileObj, key, res.data.auth_token)
            const hook = {
              next: (res) => {
                // const total = res.total
                // console.log('进度：' + parseInt(total.percent) + '% ')
              },
              error: (err) => {
                this.$message.error(err)
              },
              complete: (res) => {
                // let WH = null
                // this.getSize(`${this.constv.QINIU_IMAGE_CND_URL}${res.key}`, function (width, height) {
                //   console.log(width, height)
                //   WH = { 'width': width, 'height': height }
                // })
                this.previewFile = file
                this.$emit('fnUploadSuccess', this.field, res.key)
                this.uploading = false
                this.isUploadSuccess = true
                this.$message.success('上传成功')
              }
            }
            observable.subscribe(hook)
          })
        })
        .catch(() => {})
    }
  }
}
</script>
